import React from 'react'
export default class Footer extends React.Component {
    render() {
        return (
            <div className="footer_main" style={{ paddingBottom: "10px" }}>
                <h4>pratiktiwari.com</h4>
            </div>
        )
    }
}